// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__b9PjU","containerFooter":"styles_containerFooter__ofr0Z","icons":"styles_icons__rwPLQ","details":"styles_details__oTVRR","security":"styles_security__2qbLz"};